export default {
  bookExperiencePanel: 'Boka upplevelsepanel',
  calendarIcon: 'Kalenderikon',
  coverImageForResource: 'Omslagsbild för {{title}} upplevelser',
  filterBy: 'Filtrera efter {{filter}}',
  filterByDateRange: 'Filtrera efter datumintervall',
  gallery: 'Galleri',
  goBack: 'Tillbaka till föregående sida',
  hostUserIcon: 'värdanvändarikon',
  imageOf: 'Bild av {{title}}',
  interactiveMapAltText: 'Interaktiv karta med valbara {{title}}',
  mediaSlides: 'Mediabilder',
  muteVideo: 'Stäng av ljud',
  nextPhoto: 'Nästa foto',
  noVideoPlayback: 'Ingen videouppspelningskapacitet',
  pauseVideo: 'Pausa video',
  photoOf: 'foto av {{name}}',
  playVideo: 'Spela upp video',
  previousPhoto: 'Föregående foto',
  moreFiltersAndExperiences: 'Fler filter och upplevelser',
  reserveSelectedSlot: 'Reservera vald tid',
  reviewRating: 'Recensionsbetyg {{rating}} av 5',
  overallReviewRating: 'Övergripande recensionsbetyg {{rating}} av 5',
  selectCountryCodeForPhoneNumber: 'Välj landskod för telefonnummer',
  selectDate: 'Välj datum',
  selectParticipants: 'Välj deltagare',
  selectSessionTime: 'Välj sessionstid',
  unmuteVideo: 'Slå på ljud',
  viewShoppingCart: 'Visa varukorg',
  itemsInCart: '{{count}} artiklar i varukorgen',
  zoomIn: 'Zooma in',
  zoomOut: 'Zooma ut',
  selectData: `Välj {{data}}`,
  reserveName: `Reservera {{name}}`,
  deleteReservation: 'Ta bort {{experienceTitle}} reservation',
  editParticipantsFor: 'Redigera deltagare för {{experienceTitle}}',
  enterPromoCode: 'Ange kampanjkod',
  applyPromoCode: 'Tillämpa kampanjkod',
  increaseAddOnAmount: 'Öka {{addOn}} vald',
  decreaseAddOnAmount: 'Minska {{addOn}} vald',
  addOnModal: '{{addOn}} modal',
  moreInformationAboutAddOn: 'Mer information om {{addOn}}',
  decreasePriceTierTickets: 'Minska {{priceTier}} biljetter',
  increasePriceTierTickets: 'Öka {{priceTier}} biljetter',
  downloadFilename: 'Ladda ner {{filename}}',
  viewFullDetailsDescription: 'Visa fullständig detaljbeskrivning',
  viewFullDescription: 'Visa fullständig beskrivning',
  closeModal: 'Stäng modal',
  hyattBanner: 'World Of Hyatt medlemsexklusiv banner',
  hyattBannerDesc:
    'Kampanjbanner som visar exklusiva förmåner och erbjudanden tillgängliga för World of Hyatt lojalitetsprogrammedlemmar',
  previousSlide: 'Föregående bild',
  nextSlide: 'Nästa bild',
  paginationBulletMessage: 'Gå till bild',
  exitFullscreen: 'Avsluta helskärmsvy',
  enterFullscreen: 'Öppna helskärmsvy',
  videoSlide: 'Videobild',
  imageSlide: 'Bildbild',
  of: 'av',
  noDescription: 'Ingen beskrivning',
  mediaGallery: 'Karusell - Mediagalleri',
  dateSelector: 'Datumväljare',
  nextWeek: 'Nästa vecka',
  previousWeek: 'Föregående vecka',
  scheduleAgenda: 'Schemaagenda',
  scheduleNav: 'Schemanavigering',
  scheduleViewSelector: 'Schemavyväljare',
  selectedDateAriaLabel: '{{date}}, vald',
  tapToBookExperience: 'Boka {{title}}',
  bookExperienceAriaLabel: 'Boka {{title}}',
  joinWaitlistAriaLabel: 'Gå med i väntelistan för {{title}}',
};
